var generator = function generator(generatorFunction) {
  return generatorFunction.constructor && generatorFunction.constructor.name === "GeneratorFunction";
};
export { generator };